
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.6701 18.17L16.9501 13.45C16.4701 12.97 15.9601 12.86 15.3701 12.86L12.8301 15.4C12.8301 15.99 12.9401 16.51 13.4201 16.98L18.1401 21.7C18.5301 22.09 19.1601 22.09 19.5501 21.7L21.6701 19.58C22.0601 19.2 22.0601 18.56 21.6701 18.17Z' fill='#323232'/><path d='M16.6301 9.49001C17.0201 9.88001 17.6501 9.88001 18.0401 9.49001L18.7501 8.78001L20.8701 10.9C22.0401 9.73001 22.0401 7.83001 20.8701 6.66001L18.0401 3.83001C17.6501 3.44001 17.0201 3.44001 16.6301 3.83001L15.9201 4.54001V2.00001C15.9201 1.38001 15.1601 1.05001 14.7101 1.50001L12.1701 4.04001C11.7201 4.49001 12.0501 5.25001 12.6701 5.25001H15.2101L14.5001 5.96001C14.1101 6.35001 14.1101 6.98001 14.5001 7.37001L14.8501 7.72001L11.9601 10.61L7.85006 6.48001V5.48001C7.85006 5.21001 7.74006 4.96001 7.56006 4.77001L5.54006 2.74001C5.15006 2.35001 4.52006 2.35001 4.13006 2.74001L2.71006 4.16001C2.32006 4.55001 2.32006 5.18001 2.71006 5.57001L4.73006 7.60001C4.92006 7.79001 5.17006 7.89001 5.44006 7.89001H6.44006L10.5701 12.02L9.72006 12.87H8.42006C7.89006 12.87 7.38006 13.08 7.01006 13.46L2.29006 18.18C1.90006 18.57 1.90006 19.2 2.29006 19.59L4.41006 21.71C4.80006 22.1 5.43006 22.1 5.82006 21.71L10.5401 16.99C10.9201 16.61 11.1301 16.11 11.1301 15.58V14.29L16.2801 9.14001L16.6301 9.49001Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-handyman`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHandyman

    ```js
    <b-new-b-icon-handyman />
    ```
</docs>


